import { useFlags } from 'launchdarkly-react-client-sdk';

const CASH_BACK_SURFACES_CONFIG_FLAG_KEY = 'fintech.incentives.cash-back-surfaces.config';

const CASH_BACK_SURFACE_KEYS = [
  'cart',
  'checkout',
  'homeBanner',
  'kiosk',
  'orderConfirmation',
  'pbbSignup',
  'productDescription',
] as const;

export type CashBackSurfacesConfig = Record<typeof CASH_BACK_SURFACE_KEYS[number], boolean>;

const DEFAULT_CASH_BACK_SURFACES_CONFIG: CashBackSurfacesConfig = {
  cart: false,
  checkout: false,
  homeBanner: false,
  kiosk: false,
  orderConfirmation: false,
  pbbSignup: false,
  productDescription: false,
};

// LD flag values are untyped JSON; normalize each known leaf independently so one
// malformed leaf never disables correctly typed siblings. Unknown keys are ignored.
export function normalizeCashBackSurfacesConfig(value: unknown): CashBackSurfacesConfig {
  const config = { ...DEFAULT_CASH_BACK_SURFACES_CONFIG };
  if (value === null || typeof value !== 'object' || Array.isArray(value)) {
    return config;
  }
  const record = value as Record<string, unknown>;
  CASH_BACK_SURFACE_KEYS.forEach((key) => {
    const leaf = record[key];
    config[key] = typeof leaf === 'boolean' ? leaf : false;
  });
  return config;
}

export function useCashBackSurfacesConfig(): CashBackSurfacesConfig {
  const flags = useFlags();
  return normalizeCashBackSurfacesConfig(flags[CASH_BACK_SURFACES_CONFIG_FLAG_KEY]);
}
